(function () {
    'use strict';

    angular.module("imApp").factory("custactPlanService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 799,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 807,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
